import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { CommonGlobalService } from '../../../services/common-global.service';
import { LineGraphService } from '../../../services/line-graph.service';

@Component({
  selector: 'app-performance-graphs',
  templateUrl: './performance-graphs.component.html',
  styleUrls: ['./performance-graphs.component.scss'],
  providers: [MessageService]
})
export class PerformanceGraphsComponent implements OnInit {
  deviceIp?: string;
  lineId: number;
  lineName: string;

  changesSubscriber: Subscription;

  fromDate: Date = new Date(new Date().setDate(new Date().getDate() - 1));
  toDate: Date = new Date();

  graphDataExist: boolean = false;

  chartOptions1: any;
  chartOptions2: any;
  chartOptions3: any;
  chartOptions4: any;

  chart: any = {};
  chartLine: any = {};
  chart2: any = {};
  chartLine2: any = {};

  series: any[] = [];
  result: PingResultRequestDto[];
  blocked: boolean = false;
  breadItems: MenuItem[];

  minSelectableDate: Date;
  maxSelectableDate: Date;

  constructor(private lineGraphService: LineGraphService, private messageService: MessageService, private activatedRoute: ActivatedRoute
    , private location: Location, private router: Router, private commonGlobalService: CommonGlobalService) {
    this.minSelectableDate =new Date( new Date().setMonth(new Date().getMonth() - 3));
    this.maxSelectableDate = new Date();

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.lineName = this.commonGlobalService.lineName;

    this.deviceIp = this.commonGlobalService.ipAddress;
    if (this.deviceIp)
      this.DrawGraph();
    else {
          this.messageService.add({ severity: 'error', summary: 'ucid not retrieved', detail: 'unable to show page contents' });
        }
    this.checkUrlToGetCode();

    this.breadItems = [
      { label: 'Home', routerLink: '/' },
      { label: 'LineDetails', routerLink: '/linedetails/'+this.lineId },
      { label: 'Line Performance Graph' }
    ];
  }

  checkUrlToGetCode() {
    this.activatedRoute.params.subscribe(
      (params) => {
        this.lineId = params["id"];
        //let tmpip = params["ip"];
        //if (tmpip) {
        //  this.deviceIp = tmpip;
        //  this.DrawGraph();
        //}
        //else {
        //  this.messageService.add({ severity: 'error', summary: 'ucid not retrieved', detail: 'unable to show page contents' });
        //}

        //const newUrl = '/device-graph/' + this.lineId;
        //this.location.replaceState(newUrl);
        //return;
      }

    );
  }





  getDevicePingResultData(devcieIp: string, fromDate: any, toDate: any) {
    this.blocked = true;
    this.destroyChartEvent();
    this.graphDataExist = false;
    var toDateAfterOneHour;
    var finalToDate = toDate;
    if (this.toDate == new Date()) {
      toDateAfterOneHour = new Date(new Date().setHours(new Date().getHours() + 1));
      finalToDate = toDateAfterOneHour;
    }
    this.lineGraphService.getDevicePingResult(devcieIp, fromDate, finalToDate).subscribe(async (res: any[]) => {
      if (res) {
        this.result = res;
        this.graphDataExist = true;
        let rrr = res;
        this.chartOptions1 = {
          series: [
            {
              name: "series1",
              //data:it takes the x,y
              data: await this.generateDayTimePingResult(res)
            }
          ],
          chart: {
            id: "chart2",
            type: "line",
            height: 330,
            toolbar: {
              autoSelected: "pan",
              show: false
            }
          },

          colors: ["lightgreen"],
          stroke: {
            width: 4
          },
          dataLabels: {
            enabled: false
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              title: {
                formatter: function (value1, value2) {
                  let time = new Date(rrr[value2.dataPointIndex].from);
                  let hours = time.getHours().toString(); if (hours.length == 1) hours = "0" + hours;
                  let minutes = time.getMinutes().toString(); if (minutes.length == 1) minutes = "0" + minutes;
                  return hours + ":" + minutes;
                }
              }

            }
          },
          markers: {
            size: 0
          },
          xaxis: {
            type: "datetime",
            labels: {
              datetimeUTC: false,
            },
            title: {
              text: 'Time'
            }
          },
          yaxis: {
            title: {
              text: 'Latency Avg time',
              min: 0
            }
          },
          noData: {
            text: 'No Data Available',
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            color: '#EE7600',
            fontSize: '14px',
            style: {
              fontFamily: undefined
            }
          }
        }

        this.chartOptions2 = {
          series: [
            {
              name: "series1",
              data: await this.generateDayTimePingResult(res)
            }
          ],
          chart: {
            id: "chart1",
            height: 130,
            type: "area",
            brush: {
              target: "chart2",
              enabled: true
            },
            selection: {
              enabled: true,
              xaxis: {
                min: ((new Date(toDate).getTime()) - (new Date(fromDate).getTime()) >= 6) ? (new Date(toDate).getTime() - 60 * 60 * 1000 * 6) : ((new Date(res[res.length - 1].timeStamp).getTime()) - (20 * 60 * 1000)).toLocaleString(),
                max: new Date(toDate).getTime()
              }
            }
          },
          colors: ["#008FFB"],
          fill: {
            type: "gradient",
            gradient: {
              opacityFrom: 0.91,
              opacityTo: 0.1
            }
          },
          xaxis: {
            type: "datetime",
            tooltip: {
              enabled: false
            },
            labels: {
              datetimeUTC: false,
            },
            title: {
              text: 'Time'
            }
          },
          yaxis: {
            tickAmount: 3,
            title: {
              text: 'Latency Avg Time'
            }
          },
          noData: {
            text: 'No Data Available',
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            color: '#EE7600',
            fontSize: '14px',
            style: {
              fontFamily: undefined
            }
          }
        };

        this.chartOptions3 = {
          series: [
            {
              name: "series2",
              //data:it takes the x,y
              data: await this.generateDayTimePingDroppingResult(res)
            }
          ],
          chart: {
            id: "chart4",
            type: "line",
            height: 330,
            toolbar: {
              autoSelected: "pan",
              show: false
            }
          },

          colors: ["#ff0000"],
          stroke: {
            width: 4
          },
          dataLabels: {
            enabled: false
          },
          fill: {
            opacity: 1
          },
          tooltip: {
            y: {
              title: {
                formatter: function (value1, value2) {
                  let time = new Date(rrr[value2.dataPointIndex].from);
                  let hours = time.getHours().toString(); if (hours.length == 1) hours = "0" + hours;
                  let minutes = time.getMinutes().toString(); if (minutes.length == 1) minutes = "0" + minutes;
                  return hours + ":" + minutes;
                }
              }

            }
          },
          markers: {
            size: 0
          },
          xaxis: {
            type: "datetime",
            labels: {
              datetimeUTC: false,
            },
            title: {
              text: 'Time'
            }
          },
          yaxis: {
            title: {
              text: 'Dropping Percent Avg',
              min: 0
            }
          },
          noData: {
            text: 'No Data Available',
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            color: '#EE7600',
            fontSize: '14px',
            style: {
              fontFamily: undefined
            }
          }
        }

        this.chartOptions4 = {
          series: [
            {
              name: "series2",
              data: await this.generateDayTimePingDroppingResult(res)
            }
          ],
          chart: {
            id: "chart3",
            height: 130,
            type: "area",
            brush: {
              target: "chart4",
              enabled: true,
              autoScaleYaxis: false
            },
            selection: {
              enabled: true,
              xaxis: {
                min: ((new Date(toDate).getTime()) - (new Date(fromDate).getTime()) >= 6) ? (new Date(toDate).getTime() - 60 * 60 * 1000 * 6) : ((new Date(res[res.length - 1].timeStamp).getTime()) - (20 * 60 * 1000)).toLocaleString(),
                max: new Date(toDate).getTime()
              }
            }
          },
          colors: ["#008FFB"],
          fill: {
            type: "gradient",
            gradient: {
              opacityFrom: 0.91,
              opacityTo: 0.1
            }
          },
          xaxis: {
            type: "datetime",
            tooltip: {
              enabled: false
            },
            labels: {
              datetimeUTC: false,
            },
            title: {
              text: 'Time'
            }
          },
          yaxis: {
            tickAmount: 3,
            title: {
              text: 'Dropping Percent Avg'
            }
          },
          noData: {
            text: 'No Data Available',
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            color: '#EE7600',
            fontSize: '14px',
            style: {
              fontFamily: undefined
            }
          }
        };


        this.chart = new ApexCharts(document.querySelector("#chart-line"), this.chartOptions1);
        this.chart.render();

        this.chartLine = new ApexCharts(document.querySelector("#chart-line2"), this.chartOptions2);
        this.chartLine.render();

        this.chart2 = new ApexCharts(document.querySelector("#chart-line3"), this.chartOptions3);
        this.chart2.render();

        this.chartLine2 = new ApexCharts(document.querySelector("#chart-line4"), this.chartOptions4);
        this.chartLine2.render();

        //setTimeout(() => {
        //  this.chartLine2 = new ApexCharts(document.querySelector("#chart-line4"), this.chartOptions4);
        //  this.chartLine2.render();
        //}, 100);

        this.chart.updateOptions({
          title: {
            text: 'Delay graph'
          }
        })
        this.chart2.updateOptions({
          title: {
            text: 'Dropping graph'
          }
        })
      }
      this.blocked = false;

    },
      (error) => {
        this.blocked = false;
        this.messageService.add({ severity: 'error', summary: 'Graph', detail: 'Could not retrieve data todraw the graph' });
      }
    );



  }

  pad2ndNumber(inputNumber: number): string {
    let inputString = inputNumber.toString();
    if (inputString.length == 1) inputString = "0" + inputString.toString();
    return inputString;
  }

  async generateDayTimePingResult(result: any[]) {
    var i = 0;
    this.series = [];

    var from = this.fromDate.getTime();
    var getapi = Date.parse(result[i]?.from.toString());
    if (getapi > from) {
      //this.series.push([this.fromDate.toISOString(), '0'])
    }

    while (i < result.length) {
      if (result[i].from > this.fromDate) {

      }
      var x = result[i].from;
      var y = result[i].averageDelay.toFixed(3);
      this.series.push([x, y]);
      i++;
    }
    if (Date.parse(result[i - 1]?.from.toString()) < this.toDate.getTime()) {
      // this.series.push([this.toDate.toISOString(), '0']);
    }
    return this.series;

  }

  async generateDayTimePingDroppingResult(result: any[]) {
    var i = 0;
    this.series = [];

    var from = this.fromDate.getTime();
    var getapi = Date.parse(result[i]?.from.toString());
    if (getapi > from) {
      //this.series.push([this.fromDate.toISOString(), '0'])
    }

    while (i < result.length) {
      if (result[i].from > this.fromDate) {

      }
      var x = result[i].from;
      var y = (result[i].totalPacketLoss * 100).toFixed(3);
      this.series.push([x, y]);
      i++;
    }
    if (Date.parse(result[i - 1]?.from.toString()) < this.toDate.getTime()) {
      // this.series.push([this.toDate.toISOString(), '0']);
    }
    return this.series;

  }


  DrawGraph() {
    if (!this.deviceIp) {
      this.messageService.add({ severity: 'error', summary: 'Select Device First', detail: 'there is no device selected to draw the graph' });

    }
    else {
      let fromdate;
      let current = new Date();
      fromdate = new Date(current.setDate(current.getDate() - 1));
      if (!this.fromDate)
        this.fromDate = fromdate;
      if (!this.toDate)
        this.toDate = new Date();

      this.getDevicePingResultData(this.deviceIp, this.fromDate, this.toDate);
    }

  }


  destroyChartEvent() {
    if (this.chart instanceof ApexCharts) {
      (<ApexCharts>this.chart).destroy();
    }

    if (this.chartLine instanceof ApexCharts) {
      (<ApexCharts>this.chartLine).destroy();
    }
    if (this.chart2 instanceof ApexCharts) {
      (<ApexCharts>this.chart2).destroy();
    }

    if (this.chartLine2 instanceof ApexCharts) {
      (<ApexCharts>this.chartLine2).destroy();
    }

  }


  ngOnDestroy(): void {
    this.destroyChartEvent();
    //this.changesSubscriber.unsubscribe();
  }


  drawWeek() {
    let today = new Date();
    today.setDate(today.getDate() - 7);
    this.fromDate = new Date(today);
    this.DrawGraph();
  }
  drawMonth() {
    let today = new Date();
    today.setDate(today.getDate() - 30);
    this.fromDate = new Date(today);
    this.DrawGraph();
  }

}

export class PingResultRequestDto {
  timeStamp: Date;
  avgTime: number;

}
